import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:publicationId|creatorMemberId|matchedLocationId|locationId|parentLocationId|id)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

export const journeyDiscoveryApi = {
  /** SEARCH-E3：GEO／JOURNEY suggestions（q 最短 2 code points；limit 預設 8）。 */
  suggestions: (params = {}, options = {}) => {
    const query = {
      q: params.q == null ? '' : String(params.q),
      limit: params.limit ?? 8,
    };
    return travelClient.get(travelEndpoints.discoverySuggestions, {
      params: query,
      signal: options.signal,
      ...snowflakeJson,
    });
  },

  searchJourneys: (params = {}, options = {}) => {
    const query = {
      sort: params.sort || 'LATEST',
      limit: params.limit ?? 20,
    };
    if (params.destinationKey) query.destinationKey = params.destinationKey;
    if (params.cursorEngagementCount != null && params.cursorEngagementCount !== '') query.cursorEngagementCount = params.cursorEngagementCount;
    if (params.titleQuery != null && String(params.titleQuery).trim()) query.titleQuery = params.titleQuery;
    if (params.scope === 'FOLLOWING') query.scope = 'FOLLOWING';
    if (params.locationId != null && params.locationId !== '') query.locationId = params.locationId;
    if (params.budgetMin != null && params.budgetMin !== '') query.budgetMin = params.budgetMin;
    if (params.budgetMax != null && params.budgetMax !== '') query.budgetMax = params.budgetMax;
    if (params.currency) query.currency = params.currency;
    if (params.minDays != null && params.minDays !== '') query.minDays = params.minDays;
    if (params.maxDays != null && params.maxDays !== '') query.maxDays = params.maxDays;
    if (params.q != null && String(params.q).trim() !== '') query.q = params.q;
    if (params.cursorPublishedAt) query.cursorPublishedAt = params.cursorPublishedAt;
    if (params.cursorHotScore != null && params.cursorHotScore !== '') query.cursorHotScore = params.cursorHotScore;
    if (params.cursorPublicationId != null && params.cursorPublicationId !== '') {
      query.cursorPublicationId = params.cursorPublicationId;
    }
    return travelClient.get(travelEndpoints.discoveryJourneys, {
      params: query,
      signal: options.signal,
      ...snowflakeJson,
    });
  },
};
